import Navigation from "../components/Navigation/Navigation"
import { ProductInfo } from "../components/Products/productinfo"

export const ProductInfoPage = () => {
    return <>
        <Navigation />
        <ProductInfo />
    </>
}